export default __webpack_public_path__ + "static/media/lock.1bd4a922.svg";